import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { exportNoteToPDF } from '../utils/pdfExport';

const { FiDownload, FiLoader } = FiIcons;

const PDFDownloadButton = ({ contentRef, studentName, lessonDate, disabled = false }) => {
  const [isExporting, setIsExporting] = useState(false);

  const handleDownload = async () => {
    if (!contentRef?.current || isExporting || disabled) {
      return;
    }

    try {
      setIsExporting(true);
      await exportNoteToPDF(contentRef.current, studentName, lessonDate);
    } catch (error) {
      console.error('PDF export failed:', error);
      // Show user-friendly error message
      alert('Failed to export PDF. Please try again.');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <motion.button
      onClick={handleDownload}
      disabled={disabled || isExporting || !contentRef?.current}
      className={`
        inline-flex items-center justify-center h-8 w-8 rounded-full border text-sm
        ${disabled || isExporting || !contentRef?.current
          ? 'opacity-50 cursor-not-allowed border-gray-200 text-gray-400'
          : 'hover:bg-gray-50 cursor-pointer border-gray-200 text-gray-600 hover:text-gray-700'
        }
      `}
      whileHover={!disabled && !isExporting && contentRef?.current ? { scale: 1.05 } : {}}
      whileTap={!disabled && !isExporting && contentRef?.current ? { scale: 0.95 } : {}}
      title="Download PDF"
      aria-label="Download PDF"
    >
      {isExporting ? (
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
        >
          <SafeIcon icon={FiLoader} className="text-sm" />
        </motion.div>
      ) : (
        <SafeIcon icon={FiDownload} className="text-sm" />
      )}
    </motion.button>
  );
};

export default PDFDownloadButton;